import { reactive } from "vue";

export interface UsageBasedFeaturesModalState {
  show: boolean;
  onAddPaymentMethod: ((amountCents?: number) => void) | null;
  onProceed: (() => void) | null;
  onPurchaseCredits: (() => void) | null;
  hasPaymentMethod: boolean;
  balanceCents: number;
}

export interface InsufficientCreditsModalState {
  show: boolean;
  message: string;
  title: string;
  ctaLabel: string;
  showPurchaseHint: boolean;
  ctaPath: string;
}

const usageBasedFeaturesModal = reactive<UsageBasedFeaturesModalState>({
  show: false,
  onAddPaymentMethod: null,
  onProceed: null,
  onPurchaseCredits: null,
  hasPaymentMethod: false,
  balanceCents: 0,
});

const insufficientCreditsModal = reactive<InsufficientCreditsModalState>({
  show: false,
  message: "",
  title: "Insufficient Credits",
  ctaLabel: "Purchase Credits",
  showPurchaseHint: true,
  ctaPath: "/settings/billing?openPurchase=true",
});

export function useSubscriptionModals() {
  function showUsageBasedFeaturesModal(payload: {
    onAddPaymentMethod?: ((amountCents?: number) => void) | null;
    onProceed?: (() => void) | null;
    onPurchaseCredits?: (() => void) | null;
    hasPaymentMethod?: boolean;
    balanceCents?: number;
  }) {
    usageBasedFeaturesModal.show = true;
    usageBasedFeaturesModal.onAddPaymentMethod = payload.onAddPaymentMethod || null;
    usageBasedFeaturesModal.onProceed = payload.onProceed || null;
    usageBasedFeaturesModal.onPurchaseCredits = payload.onPurchaseCredits || null;
    usageBasedFeaturesModal.hasPaymentMethod = payload.hasPaymentMethod ?? false;
    usageBasedFeaturesModal.balanceCents = payload.balanceCents ?? 0;
  }

  function hideUsageBasedFeaturesModal() {
    usageBasedFeaturesModal.show = false;
    usageBasedFeaturesModal.onAddPaymentMethod = null;
    usageBasedFeaturesModal.onProceed = null;
    usageBasedFeaturesModal.onPurchaseCredits = null;
    usageBasedFeaturesModal.hasPaymentMethod = false;
    usageBasedFeaturesModal.balanceCents = 0;
  }

  function showInsufficientCreditsModal(
    message?: string,
    title?: string,
    ctaLabel?: string,
    showPurchaseHint?: boolean,
    ctaPath?: string
  ) {
    insufficientCreditsModal.show = true;
    insufficientCreditsModal.message =
      message ||
      "Your credit balance is too low. Purchase credits to continue using paid features.";
    insufficientCreditsModal.title = title || "Insufficient Credits";
    insufficientCreditsModal.ctaLabel = ctaLabel || "Purchase Credits";
    insufficientCreditsModal.showPurchaseHint = showPurchaseHint ?? true;
    insufficientCreditsModal.ctaPath = ctaPath || "/settings/billing?openPurchase=true";
  }

  function hideInsufficientCreditsModal() {
    insufficientCreditsModal.show = false;
    insufficientCreditsModal.message = "";
    insufficientCreditsModal.title = "Insufficient Credits";
    insufficientCreditsModal.ctaLabel = "Purchase Credits";
    insufficientCreditsModal.showPurchaseHint = true;
    insufficientCreditsModal.ctaPath = "/settings/billing?openPurchase=true";
  }

  return {
    usageBasedFeaturesModal,
    insufficientCreditsModal,
    showUsageBasedFeaturesModal,
    hideUsageBasedFeaturesModal,
    showInsufficientCreditsModal,
    hideInsufficientCreditsModal,
  };
}
